import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'

interface CodingStatusChoice {
  value: string
  label: string
}

export const useCodingStatusStore = defineStore('codingStatus', () => {
  const codingStatusChoices = ref<CodingStatusChoice[]>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const fetchCodingStatusChoices = async () => {
    isLoading.value = true
    error.value = null

    try {
      const response = await api.get(API_ROUTES.GET_CODING_STATUS_CHOICES)
      codingStatusChoices.value = response.data
      return response.data
    } catch (err: any) {
      error.value = err.response?.data?.message || 'Failed to fetch coding status choices'
      console.error('Error fetching coding status choices:', err)
      return []
    } finally {
      isLoading.value = false
    }
  }

  return {
    codingStatusChoices,
    isLoading,
    error,
    fetchCodingStatusChoices
  }
})

export type { CodingStatusChoice } 